import { ref, nextTick, onMounted, watch } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4f984250"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "echarts-content"
};
const _hoisted_2 = {
  class: "filter-new-content"
};
const _hoisted_3 = {
  class: "reason-content"
};
const _hoisted_4 = {
  class: "target-flex-content"
};
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  class: "filter-content"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "结算货币：", -1));
const _hoisted_8 = {
  key: 0,
  id: "canvas"
};
import * as echarts from 'echarts/core';
import { LineChart } from 'echarts/charts';
import { TitleComponent, TooltipComponent, GridComponent,
// 数据集组件
DatasetComponent,
// 内置数据转换器组件 (filter, sort)
TransformComponent, LegendComponent, DataZoomComponent } from 'echarts/components';
import { LabelLayout, UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
import Empty from '@/components/Empty.vue';
import { queryEchartResult } from '@/api/pay';
import { onUnmounted } from 'vue';
import { checkboxList } from '@/views/paidEventBillboard/components/data';
import { message } from 'ant-design-vue';
// 注册必须的组件
export default /*#__PURE__*/_defineComponent({
  __name: 'EchartsContent',
  setup(__props, {
    expose
  }) {
    echarts.use([TitleComponent, TooltipComponent, GridComponent, DatasetComponent, TransformComponent, LineChart, LabelLayout, UniversalTransition, CanvasRenderer, LegendComponent, DataZoomComponent]);
    const languageList = [{
      title: '销售额(USD)',
      dataIndex: 'pay_purchase_sale_amount',
      key: 'pay_purchase_sale_amount',
      sorter: true,
      width: 100,
      checked: false,
      desc: '成功支付的订单价格总和（美元） '
    }, {
      title: '销售额(CNY)',
      dataIndex: 'pay_purchase_sale_amount_cny',
      key: 'pay_purchase_sale_amount_cny',
      sorter: true,
      width: 100,
      checked: false,
      desc: '成功支付的订单价格总和（人民币）'
    }, {
      title: '收入(USD)',
      dataIndex: 'pay_purchase_income_amount',
      key: 'pay_purchase_income_amount',
      sorter: true,
      width: 100,
      checked: false,
      desc: '平台分成后的实际收益（美元）'
    }, {
      title: '收入(CNY)',
      dataIndex: 'pay_purchase_income_amount_cny',
      key: 'pay_purchase_income_amount_cny',
      sorter: true,
      width: 100,
      checked: false,
      desc: '平台分成后的实际收益（人民币）'
    }, {
      title: '人均付费(USD)',
      dataIndex: 'pay_purchase_user_amount',
      key: 'pay_purchase_user_amount',
      sorter: true,
      width: 100,
      checked: false,
      desc: '平均每个付费用户贡献的订单金额（美元）'
    }, {
      title: '人均付费(CNY)',
      dataIndex: 'pay_purchase_user_amount_cny',
      key: 'pay_purchase_user_amount_cny',
      sorter: true,
      width: 100,
      checked: false,
      desc: '平均每个付费用户贡献的订单金额（人民币）'
    }, {
      title: '单次付费(USD)',
      dataIndex: 'pay_purchase_single_amount',
      key: 'pay_purchase_single_amount',
      sorter: true,
      width: 100,
      checked: false,
      desc: '平均每笔订单贡献的订单金额（美元）'
    }, {
      title: '单次付费(CNY)',
      dataIndex: 'pay_purchase_single_amount_cny',
      key: 'pay_purchase_single_amount_cny',
      sorter: true,
      width: 100,
      checked: false,
      desc: '平均每笔订单贡献的订单金额（人民币）'
    }, {
      title: '付费ARPU(USD)',
      dataIndex: 'pay_purchase_arpu',
      key: 'pay_purchase_arpu',
      sorter: true,
      width: 100,
      checked: false,
      desc: '平均每个活跃用户贡献的内购收入（美元）'
    }, {
      title: '付费ARPU(CNY)',
      dataIndex: 'pay_purchase_arpu_cny',
      key: 'pay_purchase_arpu_cny',
      sorter: true,
      width: 100,
      checked: false,
      desc: '平均每个活跃用户贡献的内购收入（人民币）'
    }, {
      title: '首次付费用户数',
      dataIndex: 'pay_purchase_first_user',
      key: 'pay_purchase_first_user',
      sorter: true,
      width: 100,
      checked: false,
      desc: '从首次启动至今(和筛选时间无关)，在当天且仅在当天累计付费次数为1的用户(累计付费次数为用户属性，该属性会随时间变化而变化)'
    }, {
      title: '首次付费用户占比',
      dataIndex: 'pay_purchase_first_user_rate',
      key: 'pay_purchase_first_user_rate',
      sorter: true,
      width: 100,
      checked: false,
      desc: '首次付费用户数/所有付费用户数'
    }, {
      title: '付费eCPM(USD)',
      dataIndex: 'pay_purchase_cpm',
      key: 'pay_purchase_cpm',
      sorter: true,
      width: 100,
      checked: false,
      desc: '每一千次展示可以获得的内购收入（美元）'
    }, {
      title: '付费eCPM(CNY)',
      dataIndex: 'pay_purchase_cpm_cny',
      key: 'pay_purchase_cpm_cny',
      sorter: true,
      width: 100,
      checked: false,
      desc: '每一千次展示可以获得的内购收入（人民币）'
    }];
    const xData = ref([]);
    const selectedList = ref([]);
    const seriesData = ref([]);
    const searchForm = ref({});
    const targetValue = ref(['pay_purchase_sale_amount', 'pay_purchase_arpu', 'active_user', 'new_add_user', 'pay_purchase_active_rate', 'pay_purchase_new_active_rate', 'pay_purchase_total', 'pay_purchase_user']);
    const targetList = ref([]);
    const loading = ref(false);
    const originData = ref({});
    const currency = ref(1);
    const defaultCheck = ref(true);
    const createChart = () => {
      if (!document.getElementById('canvas')) {
        return false;
      }
      echarts.dispose(document.getElementById('canvas'));
      const chartDom = document.getElementById('canvas'),
        myChart = echarts.init(chartDom);
      let options = {
        tooltip: {
          trigger: 'axis',
          enterable: true
        },
        color: ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc', '#fd7f82', '#ffa748'],
        legend: {
          data: selectedList.value,
          top: '93%'
        },
        grid: {
          left: '2.5%',
          right: '2.5%',
          bottom: '10%',
          top: 24,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xData.value
        },
        yAxis: {
          type: 'value'
        },
        series: seriesData.value
      };
      // myChart.resize()
      // myChart.clear()
      myChart.setOption(options);
      loading.value = false;
    };
    const handleData = () => {
      var _data$results, _data$results2;
      if (!originData.value.results) return;
      xData.value = [];
      seriesData.value = [];
      let data = originData.value;
      if (!((_data$results = data.results) !== null && _data$results !== void 0 && _data$results.length)) return;
      Object.keys((_data$results2 = data.results) === null || _data$results2 === void 0 ? void 0 : _data$results2[0]).forEach(item => {
        if (!['date', 'app', 'dbt_total'].includes(item) && targetValue.value.includes(item)) {
          seriesData.value = [...seriesData.value, {
            name: data.heads[item],
            enName: item,
            type: 'line',
            data: []
          }];
        }
      });
      selectedList.value = targetValue.value.map(item => data.heads[item]);
      data.results.forEach(item => {
        xData.value = [...xData.value, item.date];
        seriesData.value.forEach(i => {
          i.data = [...i.data, item[i.enName]];
        });
      });
      nextTick(() => {
        createChart();
      });
    };
    const changeTarget = e => {
      if (e.length > 8) {
        message.warning('最多选择8个指标');
        return false;
      } else {
        targetValue.value = e;
      }
      handleData();
    };
    const searchData = (searchObj = {}) => {
      searchForm.value = {
        ...searchObj
      };
      getData();
    };
    const getData = async () => {
      loading.value = true;
      let paramData = {
        ...searchForm.value,
        req: {
          ...searchForm.value.req,
          groupBy: 'dbt_total'
        }
      };
      try {
        const {
          code,
          data
        } = await queryEchartResult(paramData);
        if (code === '0') {
          originData.value = data;
          handleData();
        }
      } catch (e) {}
      loading.value = false;
    };
    const handleTarget = () => {
      targetList.value = checkboxList.value;
      changeRadio();
    };
    const changeRadio = () => {
      if (currency.value === 1) {
        targetList.value[0].children = languageList.filter(item => !item.title.includes('CNY'));
        targetValue.value = ['pay_purchase_sale_amount', 'pay_purchase_arpu', 'active_user', 'new_add_user', 'pay_purchase_active_rate', 'pay_purchase_new_active_rate', 'pay_purchase_total', 'pay_purchase_user'];
      } else {
        targetList.value[0].children = languageList.filter(item => !item.title.includes('USD'));
        targetValue.value = ['pay_purchase_sale_amount_cny', 'pay_purchase_arpu_cny', 'active_user', 'new_add_user', 'pay_purchase_active_rate', 'pay_purchase_new_active_rate', 'pay_purchase_total', 'pay_purchase_user'];
      }
      handleData();
    };
    const changeDefault = () => {
      if (defaultCheck.value) {
        targetValue.value = currency.value === 1 ? ['pay_purchase_sale_amount', 'pay_purchase_arpu', 'active_user', 'new_add_user', 'pay_purchase_active_rate', 'pay_purchase_new_active_rate', 'pay_purchase_total', 'pay_purchase_user'] : ['pay_purchase_sale_amount_cny', 'pay_purchase_arpu_cny', 'active_user', 'new_add_user', 'pay_purchase_active_rate', 'pay_purchase_new_active_rate', 'pay_purchase_total', 'pay_purchase_user'];
      } else {
        targetValue.value = [];
      }
    };
    onMounted(() => {
      handleTarget();
      if (!document.getElementById('canvas')) {
        return false;
      }
      echarts.dispose(document.getElementById('canvas'));
      const chartDom = document.getElementById('canvas'),
        myChart = echarts.init(chartDom);
      myChart.clear();
      myChart.resize();
      // window.addEventListener('resize', handleData)
    });
    onUnmounted(() => {
      // window.removeEventListener('resize', handleData)
    });
    watch(() => targetValue.value, () => {
      const targetKeys = currency.value === 1 ? ['pay_purchase_sale_amount', 'pay_purchase_arpu', 'active_user', 'new_add_user', 'pay_purchase_active_rate', 'pay_purchase_new_active_rate', 'pay_purchase_total', 'pay_purchase_user'] : ['pay_purchase_sale_amount_cny', 'pay_purchase_arpu_cny', 'active_user', 'new_add_user', 'pay_purchase_active_rate', 'pay_purchase_new_active_rate', 'pay_purchase_total', 'pay_purchase_user'];
      const isInclude = targetKeys.every(key => targetValue.value.includes(key));
      defaultCheck.value = isInclude;
    });
    expose({
      searchData
    });
    return (_ctx, _cache) => {
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      const _component_a_checkbox_group = _resolveComponent("a-checkbox-group");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_popover = _resolveComponent("a-popover");
      const _component_a_radio = _resolveComponent("a-radio");
      const _component_a_radio_group = _resolveComponent("a-radio-group");
      const _component_a_spin = _resolveComponent("a-spin");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_a_popover, {
        overlayClassName: "echart-paid-type-content",
        class: "echart-paid-type-content",
        placement: "bottomLeft"
      }, {
        content: _withCtx(() => [_createVNode(_component_a_checkbox, {
          checked: defaultCheck.value,
          "onUpdate:checked": _cache[0] || (_cache[0] = $event => defaultCheck.value = $event),
          onChange: changeDefault
        }, {
          default: _withCtx(() => [_createTextVNode("默认")]),
          _: 1
        }, 8, ["checked"]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_a_checkbox_group, {
          value: targetValue.value,
          onChange: changeTarget
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(targetList.value, item => {
            return _openBlock(), _createElementBlock("div", {
              class: "target-list",
              key: item.title
            }, [_createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, item => {
              return _openBlock(), _createElementBlock("div", {
                class: "group-list",
                key: item.dataIndex
              }, [_createVNode(_component_a_checkbox, {
                value: item.dataIndex
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
                _: 2
              }, 1032, ["value"])]);
            }), 128))]);
          }), 128))]),
          _: 1
        }, 8, ["value"])])]),
        default: _withCtx(() => [_createVNode(_component_a_button, {
          type: "link"
        }, {
          default: _withCtx(() => [_createTextVNode(" 指标 "), _createVNode(_component_svg_icon, {
            "icon-class": "arrow",
            "class-name": "arrow-icon"
          })]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_a_radio_group, {
        value: currency.value,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => currency.value = $event),
        name: "radioGroup",
        onChange: changeRadio
      }, {
        default: _withCtx(() => [_createVNode(_component_a_radio, {
          value: 1
        }, {
          default: _withCtx(() => [_createTextVNode("美元")]),
          _: 1
        }), _createVNode(_component_a_radio, {
          value: 2
        }, {
          default: _withCtx(() => [_createTextVNode("人民币")]),
          _: 1
        })]),
        _: 1
      }, 8, ["value"])])]), _createVNode(_component_a_spin, {
        spinning: loading.value
      }, {
        default: _withCtx(() => [xData.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_8)) : (_openBlock(), _createBlock(Empty, {
          key: 1
        }))]),
        _: 1
      }, 8, ["spinning"])]);
    };
  }
});